import { cn } from '../lib/utils';

const BRAND = `${process.env.PUBLIC_URL || ''}/brand`;
const markSizes = { sm: 'h-7', md: 'h-9', lg: 'h-14', xl: 'h-20' };
const wordSizes = { sm: 'h-4', md: 'h-[1.35rem]', lg: 'h-8', xl: 'h-11' };

export const LogoMark = ({ size = 'md', onDark = false, className }) => (
  <img
    src={`${BRAND}/logo-mark${onDark ? '-white' : ''}.png`}
    alt="Campia"
    className={cn(markSizes[size], 'w-auto select-none', className)}
    draggable={false}
    data-testid="logo-mark"
  />
);

export const Wordmark = ({ size = 'md', onDark = false, className }) => (
  <img
    src={`${BRAND}/wordmark${onDark ? '-white' : ''}.png`}
    alt="campia"
    className={cn(wordSizes[size], 'w-auto select-none', className)}
    draggable={false}
    data-testid="logo-wordmark"
  />
);

export const LogoLockup = ({ onDark = false, className }) => (
  <img
    src={`${BRAND}/logo-full${onDark ? '-white' : ''}.png`}
    alt="campia — Camps · Facilitators · Community"
    className={cn('w-auto select-none', className)}
    draggable={false}
    data-testid="logo-lockup"
  />
);

export const Logo = ({ size = 'md', onDark = false, hideWordOnMobile = false, className }) => (
  <span className={cn('inline-flex items-center gap-2.5', className)} data-testid="logo">
    <LogoMark size={size} onDark={onDark} />
    <Wordmark size={size} onDark={onDark} className={cn(hideWordOnMobile && 'hidden sm:block')} />
  </span>
);

export default Logo;
